var map = {
	"./BG_WALLET_MODO.png": 180,
	"./BG_WALLET_PAYDISS.png": 181,
	"./modo.png": 128,
	"./paydiss.png": 365,
	"./wallet.png": 71,
	"./wallets_virt.png": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;